import Progress from 'components/_UI/Progress';
import Text from 'components/_UI/Text';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { FullyCentered } from 'styled/alignment/Center';
import { Column } from 'styled/alignment/Column';
import { Row } from 'styled/alignment/Row';
import breakpoints from 'theme/breakpoints';
import colors from 'theme/colors';
import CardTickets from '../card/CardTickets';
import Icon from 'components/_UI/Icon';
import fonts from 'theme/fonts';
import Switch from 'components/_UI/Switch';
import Button from 'components/_UI/Button';
import Loader from 'components/_UI/Loader';
import ticketsApi from 'api/requests/tickets';
import currency from 'helpers/currency';
import { Calendar } from 'react-feather';
import { BlockContent } from 'styled/UI/BlockContent';

export default function TicketDetail({ data }) {
    const [tickets, setTickets] = useState(null);
    const [amountTotal, setAmountTotal] = useState(0);
    const [soldAmountTicket, setSoldAmountTicket] = useState(0);
    const [isLoading, setIsLoading] = useState(true);
    const [ticketTotals, setTicketTotals] = useState({});
    const [ticketPercentages, setTicketPercentages] = useState({});
    const [percentageSold, setPercentageSold] = useState(0);
    const [percentageAvailable, setPercentageAvailable] = useState(0);
    const [ticketsRevenueTotal, setTicketsRevenueTotal] = useState(0);
    const [ticketsRevenueSold, setTicketsRevenueSold] = useState(0);

    useEffect(() => {
        getEvent(data);
    }, []);

    async function getEvent(slug) {
        try {
            const { data } = await ticketsApi.getTicketForEvent(slug);

            setSoldAmountTicket(data?.tickets_sold);
            setAmountTotal(data?.tickets_total);
            setTickets(data?.tickets);
            setTicketsRevenueTotal(data?.tickets_revenue_total)
            setTicketsRevenueSold(data?.tickets_revenue_sold)

            let totals = {};
            let percentages = {};

            data?.tickets.forEach(ticket => {
                let totalCollected = 0;
                let totalEstimated = 0;
                let soldQuantity = 0;
                let totalQuantity = 0;

                ticket?.batches?.forEach(batch => {
                    soldQuantity += (batch.quantity - batch.quantity_available);
                    totalQuantity += batch.quantity;
                    totalCollected += batch?.value_sold_without_tax;
                    totalEstimated += batch.quantity * batch.price;
                });

                totals[ticket.id] = {
                    collected: totalCollected,
                    estimated: totalEstimated
                };

                percentages[ticket.id] = totalQuantity > 0
                    ? (soldQuantity / totalQuantity) * 100
                    : 0;
            });

            setTicketTotals(totals);
            setTicketPercentages(percentages);

            const globalPercentageSold = data?.tickets_total > 0
                ? (data?.tickets_sold / data?.tickets_total) * 100
                : 0;

            setPercentageSold(globalPercentageSold);
            setPercentageAvailable(100 - globalPercentageSold);

        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    }

    return (
        <>
            {!isLoading ? (
                <ContainerDetail>

                    <TicketsStatistics>
                        <StatisticCardItem type='sold'>
                            <Column>
                                <Text color={colors.secondaryPurple} paddingBottom={'0'}>
                                    Ingressos vendidos
                                </Text>
                                <StyledProgressSale>
                                    <Row style={{alignItems: 'flex-end'}}>
                                        <Text color={colors.secondaryPurple} name='hero' paddingBottom={0}>
                                            {soldAmountTicket}/
                                        </Text>
                                        <Text color={colors.secondaryPurple} name='title' paddingBottom={'8px'}>
                                            {amountTotal}
                                        </Text>
                                    </Row>
                                    <CircularIcon type='sold'>
                                        <Column width='20px' height='20px'>
                                            <Icon name='ticket' color={colors.neutralLight} />
                                        </Column>
                                    </CircularIcon>
                                </StyledProgressSale>
                            </Column>

                            <Column marginTop='16px'>
                                <Progress value={Math.round(percentageSold)} bgColor={'#E9D5FF'} color={colors.secondaryPurple} />
                                <Text color={colors.secondaryPurple} marginTop={'6px'}>{Math.round(percentageSold)}% total</Text>
                            </Column>
                        </StatisticCardItem>

                        <StatisticCardItem type='toSell'>
                            <Column>
                                <Text color={colors.success} paddingBottom={'0'}>
                                    Disponíveis
                                </Text>
                                <ContentTicketToSell>
                                <Row style={{alignItems: 'flex-end'}}>
                                        <Text color={colors.success} name='hero' paddingBottom={'0'}>
                                            {amountTotal - soldAmountTicket}/
                                        </Text>
                                        <Text color={colors.success} name='title' paddingBottom={'8px'}>
                                            {amountTotal}
                                        </Text>
                                    </Row>
                                    <CircularIcon type='toSell'>
                                        <Column width='24px' height='24px'>
                                            <Icon name='ticket' color={colors.neutralLight} />
                                        </Column>
                                    </CircularIcon>
                                </ContentTicketToSell>
                            </Column>

                            <Column marginTop='16px'>
                                <Progress value={Math.round(percentageAvailable)} bgColor={'#BBF7D0'} color={colors.success} />
                                <Text marginTop={'6px'} color={colors.success}>{Math.round(percentageAvailable)}% disponivel</Text>
                            </Column>
                        </StatisticCardItem>

                        <StatisticCardItem type='general'>
                            <Column>
                                <Text color={colors.primary} paddingBottom={'0'}>
                                    Receita total
                                </Text>
                                <ContentTicketToSell>
                                    <Column>
                                        <Text color={colors.primaryDark} paddingBottom={'0'} name='title'>
                                            {currency.format(ticketsRevenueSold)}
                                        </Text>
                                        <Text color={colors.primary} paddingBottom={'0'}>
                                            de {currency.format(ticketsRevenueTotal)}
                                        </Text>
                                    </Column>
                                    <CircularIcon type='general'>
                                        <Calendar color={colors.neutralLight} />
                                    </CircularIcon>
                                </ContentTicketToSell>
                            </Column>

                            <Column marginTop='16px'>
                                <Progress
                                    value={
                                        ticketsRevenueTotal > 0
                                            ? Math.round((ticketsRevenueSold / ticketsRevenueTotal) * 100)
                                            : 0
                                    }
                                    bgColor={'#BFDBFE'}
                                    color={colors.primary}
                                />
                                <Text color={colors.primary} marginTop={'6px'}>
                                    {ticketsRevenueTotal > 0
                                        ? `${Math.round((ticketsRevenueSold / ticketsRevenueTotal) * 100)}% da meta`
                                        : '0% da meta'}
                                </Text>
                            </Column>
                        </StatisticCardItem>

                    </TicketsStatistics>

                    <BlockContent>
                        <Text name='subtitle' color={colors.nightDark}>
                            Estatísticas de Vendas por Categoria
                        </Text>

                        <Text color={colors.nightDark}>
                            Confira a porcentagem de ingressos vendidos para cada categoria e acompanhe seu desempenho.
                        </Text>
                        <ContainerProgressData>
                            {tickets?.map((el) => (
                                <ContentProgressData key={el.id}>
                                    <Row style={{ 'justifyContent': 'space-between' }}>
                                        <Text type='bold' color={colors.secondaryPurple}>{el?.name}</Text>
                                        <Text type='bold' color={colors.secondaryPurple} marginLeft={'10px'}>
                                            {Math.round(ticketPercentages[el.id])}%
                                        </Text>
                                    </Row>

                                    <Progress value={ticketPercentages[el.id]} bgColor={'#ccc'} color={colors.occasionalPurple} />

                                    {/* <Text marginTop={'10px'}>
                                        x de 50 ingressos vendidos
                                    </Text> */}
                                </ContentProgressData>
                            ))}
                        </ContainerProgressData>
                    </BlockContent>

                    <BlockContent>
                        <ContentLots>
                            <Column>
                                <Text name='subtitle' color={colors.nightDark}>Tipos de ingressos</Text>
                                <Text color={colors.night}>Acompanhe todos os seus ingressos e saiba o montante arrecadado e previsto por cada tipo de ingresso.</Text>
                            </Column>

                            <StyledTitles>
                                <ContentTitles tickets>
                                    <Text color={colors.nightDark} type='bold'>Tipos</Text>
                                </ContentTitles>
                                <ContentTitles>
                                    <Text color={colors.nightDark} type='bold'>Valor arrecadado (sem taxas)</Text>
                                </ContentTitles>
                                <ContentTitles>
                                    <Text color={colors.nightDark} type='bold'>Valor estimado</Text>
                                </ContentTitles>
                            </StyledTitles>

                            {tickets?.map((el) => (
                                <TicketsTypes key={el.id}>
                                    <Row>
                                        <ContentTickets>
                                            <CardTickets data={el} />
                                        </ContentTickets>
                                    </Row>

                                    <ContentValues>
                                        <TicketsValues>
                                            <StyledValues collected>
                                                <TextTitlesValues>
                                                    <Text color={colors.night}>Valor arrecadado (sem taxas)</Text>
                                                </TextTitlesValues>
                                                <Text color={colors.night}>
                                                    {currency.format(ticketTotals[el.id]?.collected || 0)}
                                                </Text>
                                            </StyledValues>
                                        </TicketsValues>

                                        <TicketsValues>
                                            <StyledValues>
                                                <TextTitlesValues>
                                                    <Text color={colors.night}>Valor estimado</Text>
                                                </TextTitlesValues>
                                                <Text color={colors.night}>
                                                    {currency.format(ticketTotals[el.id]?.estimated || 0)}
                                                </Text>
                                            </StyledValues>
                                        </TicketsValues>
                                    </ContentValues>
                                </TicketsTypes>
                            ))}
                        </ContentLots>
                    </BlockContent>
                </ContainerDetail >
            ) : (
                <ContentLoader>
                    <Loader />
                </ContentLoader>
            )
            }
        </>
    );
}



const ContainerDetail = styled(Column)`
    width: 100%;
`;

const StyledData = styled(Column)`
    margin-top: 30px;
    width: 100%;


    & > div > div > div > h1 {
        display: flex;
        align-items: center;
    }
`;

const ContentTickets = styled.div`
    width: 100%;
    padding-right: 20px;
    @media screen and (min-width: ${breakpoints.xm}) and (max-width: 375px) {
        width: 100%;
    }

    @media screen and (min-width: ${breakpoints.sm}) {
        width: 60%;
        padding-right: 20px;
    }
    @media screen and (min-width: ${breakpoints.lg}) {
        width: 100%;
        border-right: 1px solid ${colors.nightLight};
        padding-right: 16px;
    }
    @media screen and (min-width: ${breakpoints.xl}) {
        padding-right: 20px;
        & > div {
            width: 100%;
        }
    }
`;

const ContentData = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    flex-wrap: wrap !important;
`;

const StyledProgressSale = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
`;

const ContentTicketToSell = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
`;

const ContainerProgressData = styled.div`
    margin-top: 15px;
    display: flex;
    flex-direction: column;
    width: 100%;
    align-items: center;

    @media screen and (min-width: ${breakpoints.sm}) {
        display: flex;
        /* flex-direction: row; */
        align-items: center;
        justify-content: flex-start;
        flex-wrap: wrap;
    }
`;

const StyledTotals = styled(Column)`
    width: 100%;

    @media screen and (min-width: ${breakpoints.sm}) {
        width: 50%;
    }
`

const ContentProgressData = styled.div`
    width: 100%;
    margin-top: 24px;

    &:first-child {
        margin-top: 0;
    }
    @media screen and (min-width: ${breakpoints.sm}) {
        /* width: 220px; */
        /* margin-top: 0; */
        margin-right: 20px;

    }
`;

const ContentLots = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 20px;
    margin-bottom: 20px;
`;

const TicketsTypes = styled(Column)`
    border-bottom: 2px solid ${colors.nightLight};
    margin-top: 25px;
    @media screen and (min-width: ${breakpoints.lg}) {
        flex-direction: row;
        border-bottom: unset;
    }
`;

const TicketsValues = styled(Row)`
    margin-top: 20px;
    justify-content: space-around;
    padding-bottom: 20px;
    @media screen and (min-width: ${breakpoints.lg}) {
        padding-bottom: unset;
        margin: unset;
    }
    width: 40%;
`;

const StyledValues = styled(Column)`
    justify-content: center;
    margin-top: 20px;
    align-items: center;
    @media screen and (min-width: ${breakpoints.lg}) {
        align-items: flex-start;
        padding-left: 30px;
    }
    ${({ collected }) => collected && `
        border-right: 1px solid ${colors.nightLight};
        @media screen and (min-width: ${breakpoints.md}) {
            padding-left: 0px;
            border-right: 1px solid ${colors.nightLight};
        }
    `}
    @media screen and (min-width: ${breakpoints.lg}) {
        margin: unset;
    }
`;

const TextTitlesValues = styled.div`
    display: flex;
    @media screen and (min-width: ${breakpoints.lg}) {
        display: none;
    }
`;

const StyledTitles = styled(Row)`
    display: none;
    width: 100%;
    @media screen and (min-width: ${breakpoints.lg}) {
        margin-top: 40px;
        display: flex;
        justify-content: space-between;
    }
`;

const ContentTitles = styled(Row)`
    justify-content: flex-start;
   
    & > p {
        font-size: ${fonts.sizes.highlight};
        color: ${colors.night}
    }

    @media screen and (min-width: ${breakpoints.md}) {
        width: 25%;
    }

    ${({ tickets }) => tickets && `
        justify-content: flex-start;
        margin-left: 10px;

        @media screen and (min-width: ${breakpoints.md}) {
            width: 50%;
            
        }
    `}

`;

const ContentValues = styled(Row)`
    justify-content: center;
`;

const ContentLoader = styled(Column)`
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const TicketsStatistics = styled(Column)`
    @media screen and (min-width: ${breakpoints.lg}) {
        flex-direction: row;
        justify-content: space-between;
        margin-bottom: 12px;
    }
`

const StatisticCardItem = styled(Column)`
    margin-bottom: 14px;
    width: 100%;
    padding: 14px;
    justify-content: space-between;

    @media screen and (min-width: ${breakpoints.lg}) {
        width: 32.5%;
    }

    ${({ type }) => type == 'sold' && `
        background-color: #F7EFFF;
        border: 1px solid ${colors.secondaryPurple};
        border-radius: 8px;
    `};
    
    ${({ type }) => type == 'toSell' && `
        border: 1px solid ${colors.success};
        border-radius: 8px;
        `};

    ${({ type }) => type == 'general' && `
        background-color: #E6F1FE;
        border: 1px solid ${colors.primary};
        border-radius: 8px;
    `};
    
`

const CircularIcon = styled(FullyCentered)`
    border-radius: 30px;
    width: 50px;
    padding: 8px;

    ${({ type }) => type == 'sold' && `
        background-color: ${colors.secondaryPurple};
    `};
    
    ${({ type }) => type == 'toSell' && `
        background-color: ${colors.success};
    `};

    ${({ type }) => type == 'general' && `
        background-color: ${colors.primary};
    `};
  `;
